export default __webpack_public_path__ + "static/media/topcharacter6.b0969fd1.jpeg";